"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineSocialSubType = void 0;
var InlineSocialSubType;
exports.InlineSocialSubType = InlineSocialSubType;

(function (InlineSocialSubType) {
  InlineSocialSubType["YOUTUBE"] = "YOUTUBE";
  InlineSocialSubType["FACEBOOK"] = "FACEBOOK";
  InlineSocialSubType["TWITTER"] = "TWITTER";
  InlineSocialSubType["INSTAGRAM"] = "INSTAGRAM";
  InlineSocialSubType["TWITCH"] = "TWITCH";
  InlineSocialSubType["SPOTIFY_AB"] = "SPOTIFY_AB";
})(InlineSocialSubType || (exports.InlineSocialSubType = InlineSocialSubType = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2VudW1zL0FydGljbGVJbmxpbmVTb2NpYWxTdWJUeXBlLnRzIl0sIm5hbWVzIjpbIklubGluZVNvY2lhbFN1YlR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7OztJQUFZQSxtQjs7O1dBQUFBLG1CO0FBQUFBLEVBQUFBLG1CO0FBQUFBLEVBQUFBLG1CO0FBQUFBLEVBQUFBLG1CO0FBQUFBLEVBQUFBLG1CO0FBQUFBLEVBQUFBLG1CO0FBQUFBLEVBQUFBLG1CO0dBQUFBLG1CLG1DQUFBQSxtQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIElubGluZVNvY2lhbFN1YlR5cGUge1xuICAgIFlPVVRVQkUgPSAnWU9VVFVCRScsXG4gICAgRkFDRUJPT0sgPSAnRkFDRUJPT0snLFxuICAgIFRXSVRURVIgPSAnVFdJVFRFUicsXG4gICAgSU5TVEFHUkFNID0gJ0lOU1RBR1JBTScsXG4gICAgVFdJVENIID0gJ1RXSVRDSCcsXG4gICAgU1BPVElGWV9BQiA9ICdTUE9USUZZX0FCJyxcbn1cbiJdfQ==